import { ActionType, Router as JazzRouter, Routes, useError } from "@cdv/jazz-ui";
import { Stack, Typography } from "@mui/material";
import { ReactElement, useEffect } from "react";
import { useRouteError } from "react-router";
import Layout from "./Layout";
import Outlet from "../Outlet";
import { Resource } from "../../utils";

const RouterError = (): ReactElement => {
  const error = useRouteError() as Error | undefined;
  const { setError } = useError();
  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [error]);
  return (
    <Stack
      direction={"column"}
      spacing={1}
      sx={{ width: "100%", height: "100vh", alignItems: "center", justifyContent: "center" }}
    >
      <Typography variant="h1">404</Typography>
      <Typography variant="h2">Stránka nenalezena</Typography>
    </Stack>
  );
};

export default function AuthRouter(): ReactElement {
  return (
    <JazzRouter error={<RouterError />} layout={<Layout />} outlet={<Outlet />}>
      <Routes resource={Resource.HomepageAuth} path="/" />
      <Routes resource={Resource.Login} path="/prihlasenie" />
      <Routes resource={"Gdpr"} path="/gdpr" />
    </JazzRouter>
  );
}
